import { render, staticRenderFns } from "./RedPacketStatisticsPane.vue?vue&type=template&id=f9cd3384&scoped=true"
import script from "./RedPacketStatisticsPane.vue?vue&type=script&lang=js"
export * from "./RedPacketStatisticsPane.vue?vue&type=script&lang=js"
import style0 from "./RedPacketStatisticsPane.vue?vue&type=style&index=0&id=f9cd3384&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cd3384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9cd3384')) {
      api.createRecord('f9cd3384', component.options)
    } else {
      api.reload('f9cd3384', component.options)
    }
    module.hot.accept("./RedPacketStatisticsPane.vue?vue&type=template&id=f9cd3384&scoped=true", function () {
      api.rerender('f9cd3384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/components/RedPacketStatisticsPane.vue"
export default component.exports